<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <BTabs :active-tab="active_tab">
              <BTab :title="$t('purchaseReport')">
                <BuyInvoiceReport/>
              </BTab>

<!--              <CTab :title="$t('reportBuyFactor')">-->
<!--                <BuyDocumentReport/>-->
<!--              </CTab>-->

              <BTab :title="$t('buyReport')">
                <BuyReport/>
              </BTab>

              <BTab :title="$t('sidebars.listProduct')">
                <ProductList fields_data="purchase"/>
              </BTab>


              <BTab :title="$t('router.listSuppliers')">
                <SupplierList/>
              </BTab>


<!--              <CTab :title="$t('purchaseReport')">-->
<!--                <BuyReportProductAndCustomers/>-->
<!--              </CTab>-->

<!--              <CTab :title="$t('supplierFactors')">-->
<!--                <SupplierBill/>-->
<!--              </CTab>-->



              <BTab v-if="get_access('buyCurrency')" :title="$t('reportCurrencyBuyFactor')">
                <CurrencyBuyDocumentReport/>
              </BTab>
              <CTab :title="$t('components.buyRet')">
                <PurchaseReturn/>
              </CTab>

            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
var items = [];
import BTabs from "../../tabs/BTabs";
import ProductList from "../products/ProductList";
import SupplierList from "./SupplierList";
import BuyReport from "../reports/BuyReport";
import SupplierBill from "./SupplierBill";
import BuyDocumentList from "./BuyDocumentList";
import CurrencyBuyDocumentList from "./CurrencyBuyDocumentList";
import BuyDocumentReport from "./BuyDocumentReport";
import CurrencyBuyDocumentReport from "./CurrencyBuyDocumentReport";
import BuyReportProductAndCustomers from "./BuyReportProductAndSuppliers";
import BuyInvoiceReport from "./BuyInvoiceReport";
import BTab from "../../tabs/BTab";
import PurchaseReturn from "./PurchaseReturn.vue";
export default {
  name: 'Login',
  components: {
    PurchaseReturn,
    BTab,
    BTabs,
    SupplierList,
    BuyReport,
    SupplierBill,
    BuyDocumentList,
    BuyDocumentReport,
    CurrencyBuyDocumentReport,
    BuyReportProductAndCustomers,
    ProductList,
    BuyInvoiceReport
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

      active_tab: 0,

    }
  }, mounted() {
    this.$root.root_validate_errors = [];


    if(this.$route.params.report_type!=null){
      this.active_tab = 4
    }
    // this.get_lists();

  }, watch: {

  },
  methods: {

  }
}

</script>
